import React from 'react';
import { Box, Table, Tooltip, InfoIcon } from 'edenred-ui';
import { Trans, useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { currency } from '@epi-helpers/numeral';
import { StatusDot } from '@epi-pages/Reports/TopupReports/TopupReports.styles';
import { formatDate, reportStatusesColors } from '@epi-pages/Reports/utils';
import { LoadRequestDetails } from '@epi-models/pages/Reports';

export const LoadRequestsTableRow = ({
  requestDate,
  loadDate,
  userFirstName,
  userLastName,
  transactionStatus,
  tooltip,
  requestedForInDays,
  loadValue,
  totalLoad,
  totalDeduction
}: LoadRequestDetails) => {
  const { t } = useTranslation();
  const { primaryFrontColor } = useTheme();
  const hideDeduction =
    transactionStatus === 'top_up_load_status.failed' ||
    transactionStatus === 'top_up_load_status.canceled';
  return (
    <Table.Row>
      <Table.Cell>
        <Box display="flex" alignItems="center" lineHeight="25px">
          {formatDate(requestDate)}
        </Box>
      </Table.Cell>
      <Table.Cell>
        <Box display="flex" alignItems="center" lineHeight="25px">
          {formatDate(loadDate) || '-'}
        </Box>
      </Table.Cell>
      <Table.Cell>
        <Box display="flex" alignItems="center">
          {userFirstName} {userLastName}
        </Box>
      </Table.Cell>
      <Table.Cell>
        <Box display="flex" alignItems="center">
          <StatusDot
            $dotColor={reportStatusesColors[transactionStatus ?? '']}
          />
          {t(
            `containers.deposit_money.reports_tab.statuses.${transactionStatus}`
          )}
          {tooltip && (
            <Tooltip
              arrow
              placement="top"
              id={`${loadDate}-tooltip`}
              componentsProps={{ tooltip: { sx: { maxWidth: '500px' } } }}
              title={
                <Trans
                  i18nKey={`containers.deposit_money.reports_tab.hints.${tooltip}`}
                />
              }
            >
              <Box id={`${loadDate}-info-icon`} ml={1}>
                <InfoIcon color={primaryFrontColor} />
              </Box>
            </Tooltip>
          )}
        </Box>
      </Table.Cell>
      <Table.Cell>
        {requestedForInDays > 0 && (
          <>
            {`${requestedForInDays} `}
            {t(
              `containers.deposit_money.reports_tab.${
                requestedForInDays > 1 ? 'days' : 'day'
              }`
            )}
          </>
        )}
      </Table.Cell>
      <Table.Cell align="right">{currency(loadValue)}</Table.Cell>
      <Table.Cell align="right">{currency(totalLoad)}</Table.Cell>
      <Table.Cell align="right">
        {hideDeduction ? '' : currency(totalDeduction)}
      </Table.Cell>
    </Table.Row>
  );
};
